let qBtns = document.querySelectorAll('.question_main_wrap .collapsible-trigger')

qBtns.forEach(btn=>{
  btn.addEventListener('click',function(){
    let targetedAns = this.parentElement.querySelector('.collapsible-content')
    let targetedSvg = this.querySelector('.icon_wrap svg')
    if(!(targetedAns.classList.contains('active'))){
      targetedAns.classList.add('active')
      let dynamicHeight = targetedAns.scrollHeight + 80
      targetedAns.style.maxHeight = dynamicHeight + 'px'
      targetedSvg.classList.add('opened')
    }
    else{
      targetedAns.style.maxHeight = "0px"
      targetedAns.classList.remove('active')
      targetedSvg.classList.remove('opened')
    }
  })
  
})